export const GLOBAL_STATE = 'City'

export const CITY = 'CITY' as const
export const CITY_CREATE = 'CITY_CREATE' as const
export const CITY_DELETE = 'CITY_DELETE' as const
export const CITY_LIST = 'CITY_LIST' as const
export const CITY_ALL = 'CITY_ALL' as const
